const initProductStickyAtc = () => {
  const stickyAtc = document.querySelector('[data-sticky-atc-wrapper]');
  if (!stickyAtc) return;

  const productControlsEl = document.querySelector('[data-product-controls]');
  const stickyAtcButton = stickyAtc.querySelector('[data-sticky-atc-btn]');
  const stickyAtcButtonMsg = stickyAtc.querySelector('[data-sticky-atc-price-msg]');
  const stickyAtcButtonSpinner = stickyAtcButton?.querySelector('[data-loading-spinner]');
  const stickyHeaderPrice = stickyAtc.querySelector('[data-sticky-atc-header-price]');
  const stickyAtcSpacer = document.querySelector('[data-sticky-atc-spacer]');
  const siblingSelectEl = stickyAtc.querySelector('[data-product-sticky-atc-sibling-select]');
  const form = document.querySelector('[data-product-main] form');
  const mainAtcButton = form?.querySelector('button[type="submit"]');
  const mainAtcButtonMsg = mainAtcButton?.querySelector('[data-atc-price-msg]');
  const mainAtcButtonSpinner = mainAtcButton?.querySelector('[data-loading-spinner]');
  const mainPriceEl = document.querySelector('[data-product-price-pdp] [data-product-price]');

  if (!form || !mainAtcButton || !stickyAtcButton) return;

  let rechargeSelectionState = null;

  const syncSpacerHeight = () => {
    if (!stickyAtcSpacer) return;
    const isHidden = stickyAtc.classList.contains('hidden');

    if (isHidden) {
      stickyAtc.classList.remove('hidden');
      stickyAtc.classList.add('invisible');
    }

    stickyAtcSpacer.style.height = `${stickyAtc.offsetHeight}px`;

    if (isHidden) {
      stickyAtc.classList.add('hidden');
      stickyAtc.classList.remove('invisible');
    }
  };

  const syncStickyState = () => {
    stickyAtcButton.disabled = mainAtcButton.disabled;
    stickyAtcButton.classList.toggle('pointer-events-none', mainAtcButton.classList.contains('pointer-events-none'));
    stickyAtcButton.classList.toggle('opacity-50', mainAtcButton.classList.contains('opacity-50'));

    if (stickyAtcButtonMsg && mainAtcButtonMsg) {
      stickyAtcButtonMsg.textContent = mainAtcButtonMsg.textContent.trim();
    }

    if (stickyAtcButtonSpinner && mainAtcButtonSpinner) {
      stickyAtcButtonSpinner.classList.toggle('hidden', mainAtcButtonSpinner.classList.contains('hidden'));
    }

    if (stickyHeaderPrice && mainPriceEl) {
      const rechargePriceText = rechargeSelectionState?.isSubscription ? rechargeSelectionState.priceText : '';
      stickyHeaderPrice.textContent = rechargePriceText || mainPriceEl.textContent.trim();
    }

    syncSpacerHeight();
  };

  const stickyStateObserver = new MutationObserver(syncStickyState);
  stickyStateObserver.observe(mainAtcButton, {
    attributes: true,
    childList: true,
    subtree: true,
    characterData: true
  });

  if (mainPriceEl) {
    stickyStateObserver.observe(mainPriceEl, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  syncStickyState();

  // Recharge owns subscription pricing in shadow DOM. The custom widget emits
  // its selected price so the sticky bar can mirror it while still submitting
  // through the main product form.
  document.addEventListener('recharge:purchase-option-change', (event) => {
    rechargeSelectionState = event.detail || null;
    syncStickyState();
  });

  if (productControlsEl) {
    const getBottom = el => el.getBoundingClientRect().top + window.scrollY + el.offsetHeight;
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const containerBottom = getBottom(productControlsEl);

      if (scrollY >= containerBottom) {
        stickyAtc.classList.remove('hidden');
      } else {
        stickyAtc.classList.add('hidden');
      }
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
  }

  window.addEventListener('resize', syncSpacerHeight);

  stickyAtcButton.addEventListener('click', () => {
    if (stickyAtcButton.disabled) return;
    mainAtcButton.click();
  });

  if (siblingSelectEl) {
    siblingSelectEl.addEventListener('change', (event) => {
      const url = event.target.value;
      if (url) window.location.href = url;
    });
  }
};

export default initProductStickyAtc;
